import { toast } from "react-toastify";
import { fetchCreateStationFailure, fetchCreateStationSuccess, fetchEditStationFailure, fetchEditStationSuccess } from "./reducer";
import { STATION_LISTING_API } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setEditSuccessMessage, setSuccessMessage } from "../../toastMessage/action";

export const createStation = (jsonObj,setLoading, navigate) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${STATION_LISTING_API}`, 'POST', jsonObj).then((response) => {
        if (response.error) {
            dispatch(fetchCreateStationFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
        if (!response.error) {
            setLoading(false)
            dispatch(fetchCreateStationSuccess(response))
            navigate('/station');
            dispatch(setEditSuccessMessage(true))
        }
    }).catch((errorResp) => { })
};